//输出通用axios实例
import axios from 'axios';
// type(0是post,1是get)
function config(url, paramsOld = {}, type = 0, isLoad = true) {
    return new Promise((resolve, reject) => {
        if (isLoad) {
            this.$Spin.show();
        }
        var endUrl, header,
            method = "post",
            endUrl = this.$store.state.baseUrl + url;

        header = {
          "Content-Type": "application/json;charset=UTF-8;",
          "yh-language": this.$store.state.pageType
        }
        let params = {
            ...paramsOld,
            language: this.$store.state.pageType === 1 ? 'zh' : 'en',
        }
        if(url === '/open/api/banner/list'){
            params.client = this.$store.state.sizeType === 'pc' ? 'pc' : 'mobile';
        }
        if (type == 1) {
            method = "get";
            for (var i in params) {
                if (endUrl.indexOf("?") == -1) {
                    endUrl = endUrl + "?" + i + "=" + params[i];
                } else {
                    endUrl = endUrl + "&" + i + "=" + params[i];
                }
            }
            params = {};
        }
        axios({
            method: method,
            url: endUrl,
            processData: false,
            headers: header,
            timeout: 40000,
            data: params
        }).then(res => {
            if (isLoad) {
                this.$Spin.hide();
            }
            var data = res.data;
            if (data.code == 200 || data.code == 0) {
              resolve(data);
            } else {
              reject(data);
              this.$Message.error(data.msg);
            }
        }).catch(err => {
            if (isLoad) {
              this.$Spin.hide();
            }
            reject(err);
            this.$Message.error(err.msg);
        })
    })
}

export default config;


// WEBPACK FOOTER //
// ./src/utils/config.js